import type { FactoryEdit } from '@indutrust/factory-model';
import { createCrudSingleEvents } from '@indutrust/shared-util';

/**
 * Single-entity CRUD events for the active factory in detail/edit views.
 *
 * Source namespace: `factory.single`. Use this group when a component needs
 * to load/edit/delete a single factory independently of collection stores.
 */
export const factorySingleEvents =
  createCrudSingleEvents<FactoryEdit>('factory.single');
